import { useState } from 'react'

type ReturnType = [boolean, () => void]

export const useToggleState = (initialState?: boolean): ReturnType => {
  const [state, setState] = useState<boolean>(initialState ?? false)
  const toggle = (): void => setState(prev => !prev)

  return [state, toggle]
}
